/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
/* prettier-ignore */ export const appInsightsConnectionString = "InstrumentationKey=8b2bb085-cb61-40ee-b8ca-ba846323eff0;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/";
